export default __webpack_public_path__ + "static/media/usb2.414df126.png";